export default __webpack_public_path__ + "static/media/1644.ce13f3fe.png";